import React, { useState, useRef, useEffect } from "react";
import { FiMapPin, FiPhone } from "react-icons/fi";
import { CiInstagram } from "react-icons/ci";

function TradingService() {
  // Gallery images for Logistics
  const galleryImages = [
    "log-1", "log-2", "log-3", "log-4", "log-5"
  ];

  const [visibleCount, setVisibleCount] = useState(6);

  return (
    <main className="main">

      {/* Page Title */}
      <div className="page-title dark-background">
        <div className="container text-center">
          <h1 className="page-heading">Logistics & Supply Chain Management</h1>
          <p className="page-subtitle">
            Reliable logistics, shipping, and supply chain solutions
          </p>
          <nav className="breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li className="current">Logistics Services</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Service Details */}
      <section className="service-details section">
        <div className="container">

          {/* Main Image */}
          <div className="main-image-container">
            <img src="/assets/logistics/log-5.webp" alt="Logistics Services" className="main-image" />
          </div>

          {/* Overview */}
          <h2>Over-View</h2>
          <p>
            Our Logistics Company Branch in Jeddah offers comprehensive logistics solutions for businesses and individuals, specializing in shipping, roadway, and air cargo services. We provide reliable, timely, and secure transportation of goods both locally and internationally.
          </p>

          {/* Branch Profile */}
          <h2>Branch Profile</h2>
          <p>
            Our Logistics Company Branch in Jeddah is a full-service logistics provider offering shipping, roadway transport, and air cargo services. Equipped with a modern fleet, advanced tracking systems, and skilled personnel, the branch handles cargo handling, warehousing, and last-mile delivery with precision and reliability.
          </p>

          {/* Services */}
          <h2>Services</h2>
          <h3>1. Shipping Services</h3>
          <div className="product-row">
            Domestic shipping, International shipping, Sea freight, Air freight, Road freight / trucking, Express courier services, Door-to-door delivery, Consolidated cargo shipments
          </div>

          <h3>2. Cargo Handling & Transportation</h3>
          <div className="product-row">
            Loading and unloading of goods, Fragile & sensitive cargo handling, Heavy equipment transportation, Temperature-controlled cargo, Container transport, Palletized shipments
          </div>

          <h3>3. Warehousing & Storage</h3>
          <div className="product-row">
            Short-term & long-term storage, Inventory management, Cold storage, Secure storage, Packaging & repackaging services
          </div>

          <h3>4. Customs & Documentation Support</h3>
          <div className="product-row">
            Import/export documentation, Customs clearance, Regulatory compliance, Shipment tracking & reporting
          </div>

          <h3>5. Specialized Logistics Solutions</h3>
          <div className="product-row">
            Project cargo handling, E-commerce logistics, Bulk transportation, Scheduled & on-demand deliveries, 3PL solutions
          </div>

          <h3>6. Technology & Tracking</h3>
          <div className="product-row">
            Real-time tracking, Digital documentation, Route optimization, Client notifications & alerts
          </div>

          <h3>7. Value-Added Services</h3>
          <div className="product-row">
            Packaging & labeling, Shipment insurance, Reverse logistics, Supply chain consultation
          </div>

        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2 className="gallery-title">Gallery</h2>
          <div className="gallery-grid">
            {galleryImages.slice(0, visibleCount).map((img, index) => (
              <LazyImage 
                key={img} 
                src={`/assets/logistics/${img}.webp`} 
                alt={`Logistics ${index + 1}`} 
                priority={index === 0} 
              />
            ))}
          </div>

          {visibleCount < galleryImages.length && (
            <div className="load-more">
              <button onClick={() => setVisibleCount(v => v + 3)}>Load More</button>
            </div>
          )}
        </div>
      </section>

      {/* Location & Contact */}
      <section className="contact-strip">
        <div className="container">
          <h3 className="contact-heading">Location & Contact</h3>
          <div className="contact-row">
            <span><FiMapPin /> King Road Tower, 12th Floor, Office-1207, Jeddah, KSA</span>
            <span><FiPhone /> +966 503357396</span>
            <a
              href="https://www.instagram.com/almac_company?igsh=MThmemIyN2d6aG8zeQ=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <CiInstagram style={{ fontSize: '28px', color: '#111' }} />
            </a>
          </div>
        </div>
      </section>

      {/* Styles */}
      <style>{`
        .page-heading { font-size: 3rem; font-weight: 800; color:#fff; text-shadow:2px2px5px rgba(0,0,0,0.6); margin-bottom:10px; }
        .page-subtitle { font-size:1.2rem; color:#e6e6e6; margin-bottom:15px; }
        h2 { font-size:2rem; margin-top:30px; margin-bottom:15px; color:#222; }
        h3 { font-size:1.6rem; margin-top:25px; margin-bottom:12px; color:#333; }
        p, .product-row { font-size:1.1rem; line-height:1.8; color:#555; margin-bottom:12px; }
        .product-row { display:flex; flex-wrap:wrap; gap:12px; }

        .main-image-container { text-align:center; margin-bottom:35px; }
        .main-image { width:100%; max-width:900px; height:auto; border-radius:12px; }

        .gallery-title { text-align:center; font-size:2rem; margin-bottom:25px; }
        .gallery-grid {
          display:grid;
          grid-template-columns:repeat(auto-fit,minmax(230px,1fr));
          gap:15px;
          margin-top:20px;
        }
        .img-wrapper { width:100%; height:220px; border-radius:12px; overflow:hidden; background:#f2f2f2; }
        .img-wrapper img { width:100%; height:100%; object-fit:cover; transition:transform 0.25s ease; }
        .img-wrapper:hover img { transform:scale(1.04); }
        .load-more { text-align:center; margin-top:20px; }
        .load-more button { padding:10px 25px; border-radius:30px; border:none; background:#111; color:#fff; cursor:pointer; font-size:14px; }

        .contact-strip { background:#fafafa; border-top:1px solid #eee; margin-top:50px; padding:40px 0; }
        .contact-heading { text-align:center; font-size:1.7rem; margin-bottom:20px; font-weight:700; color:#222; }
        .contact-row { display:flex; justify-content:center; align-items:center; gap:25px; flex-wrap:wrap; font-size:1rem; color:#333; }
        .contact-row span, .contact-row a { display:flex; align-items:center; gap:8px; text-decoration:none; font-weight:500; color:#333; }
        .contact-row svg { font-size:1.3rem; color:#111; }

        @media(max-width:991px){
          .product-row { font-size:1rem; gap:8px; }
        }
        @media(max-width:576px){
          .product-row { flex-direction:column; gap:5px; }
          .gallery-grid { grid-template-columns:repeat(auto-fit,minmax(200px,1fr)); }
        }
      `}</style>

    </main>
  );
}

/* LazyImage Component */
function LazyImage({ src, alt, priority }) {
  const ref = useRef(null);
  const [show, setShow] = useState(priority);

  useEffect(() => {
    if (priority) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShow(true);
        observer.disconnect();
      }
    }, { rootMargin: "150px" });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [priority]);

  return (
    <div className="img-wrapper" ref={ref}>
      {show && <img src={src} alt={alt} loading={priority ? "eager" : "lazy"} />}
    </div>
  );
}

export default TradingService;
